/// Navigation Action Type
export const CHANGE_SCREEN = 'CHANGE_SCREEN';
export const NAVIGATION_FORWARD = 'NAVIGATION_FORWARD';
export const NAVIGATION_BACK = 'NAVIGATION_BACK';

/// FETCH LOADING TRUE OR FALSE
export const LOAD_TRUE = 'LOAD_TRUE';
export const LOAD_FALSE = 'LOAD_FALSE';

/// Auth Action Type
export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const REGISTER_USER = 'REGISTER_USER';

/// Combo Action Type
export const COMBO_JOB_FUNCTION = "COMBO_JOB_FUNCTION";
export const COMBO_JOB_LOCATION = "COMBO_JOB_LOCATION";
export const COMBO_JOB_TYPE = "COMBO_JOB_TYPE";

// Vacancy Action Type
export const VACANCY_PL = "PL_VACANCY";
export const VACANCY_BY_SLUG = "VACANCY_BY_SLUG";
export const VACANCY_POST = "VACANCY_POST";
export const VACANCY_DELETE = "VACANCY_DELETE";

//Applicant Action Type
export const APPLICANT_POST = "APPLICANT_POST";
export const APPLICANT_GET = "APPLICANT_GET";
export const APPLICANT_GET_BYID = "APPLICANT_GET_BYID";
export const APPLICANT_PROCESS_POST = "APPLICANT_PROCESS_POST";

//Modal
export const CLOSE_MODAL = "CLOSE_MODAL";
export const OPEN_MODAL = "OPEN_MODAL";


// User
export const USER_CURRENT = "USER_CURRENT";


// WEBPACK FOOTER //
// ./src/actions/types.js